import { isAvailableDate } from "./isAvailableDate";
import { IDeliveryRange } from "types/cart/shipment-review";
import { toSafeDate } from "helpers/dates";
import type { IProduct } from "types/product";

export const isAvailableProductItem = (
    product: IProduct,
    { shipStart, shipEnd }: IDeliveryRange,
    enforceAvailableUntil: boolean,
    minimumDeliveryWindow: number
) =>
    product &&
    shipStart &&
    isAvailableDate(
        { shipStart, shipEnd },
        {
            availableFrom: toSafeDate(product.available_from),
            availableUntil: toSafeDate(product.available_until),
            enforceAvailableUntil,
            enforcePastShipStart: true,
            minimumDeliveryWindow,
        }
    );
